import * as React from 'react'
import List from '@mui/material/List'
import VendorClosedProposalItem from 'vendors/vendorUserRequestForProposals/vendorClosedProposalItem/VendorClosedProposalItem'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { Box, CircularProgress, ListItem } from '@mui/material'
import { useVendorUserProposalsHistory } from 'vendors/queries/useVendorUserQuery'
import { Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const VendorUserClosedRfps: React.FC = () => {
  const { data = [], isLoading, isError, isSuccess } = useVendorUserProposalsHistory()
  const { t } = useTranslation()

  if (isError) {
    return <Navigate to="/error" />
  }

  if (isSuccess && data.length === 0) {
    return null
  }

  return (
    <>
      <Typography sx={{ fontWeight: 'fontWeightLight', fontSize: '32px', mb: 4, mt: 5 }}>
        {t('old-proposals')}
      </Typography>
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <>
          <Divider />
          <List sx={{ p: 0 }}>
            {data.map((proposal) => (
              <ListItem sx={{ py: 2 }} key={proposal.proposalId} divider>
                <VendorClosedProposalItem proposal={proposal} />
              </ListItem>
            ))}
          </List>
        </>
      )}
    </>
  )
}

export default VendorUserClosedRfps
